var map = {
	"./กุ้ง.png": "8977",
	"./กุ้งมังกร.png": "8cbb",
	"./บาร์นะเคิล.jpg": "3c93",
	"./ปลากระพง.jpg": "0f7f",
	"./ปลากระพงขาว.png": "d56f",
	"./ปลาคอด.png": "33e0",
	"./ปลาคาร์พ.jpg": "487c",
	"./ปลาฉนาก.jpeg": "9aba",
	"./ปลาซาร์ดีน.jpeg": "af41",
	"./ปลาตาเดียว.jpg": "edde",
	"./ปลาทรายขาว.jpg": "0986",
	"./ปลาทรายแดง.jpg": "4073",
	"./ปลาทูน่า.jpeg": "5a6f",
	"./ปลามั้งค์.jpg": "bf46",
	"./ปลาลิ้นหมา.jpg": "5201",
	"./ปลาหมึกยักษ์.jpeg": "9292",
	"./ปลาเทราท์.png": "a185",
	"./ปลาเทอเบิท.jpeg": "00bf",
	"./ปลาเฮค.jpg": "abb7",
	"./ปลาแซลมอน.jpg": "3ab3",
	"./ปลาแมกเคอเรล.jpg": "edc5",
	"./ปลาแฮดดัค.jpg": "4d26",
	"./ปลาแฮร์ริง.png": "553e",
	"./ปลาไพค.jpg": "29af",
	"./ปลาไหล.jpg": "b7eb",
	"./สาหร่ายวากาเมะ.jpg": "a2b2",
	"./สาหร่ายสไปรูลิน่า.jpg": "9302",
	"./สาหร่ายเอสสปาเก็ตตี้.jpg": "7ea3",
	"./หมึกกระดอง.jpeg": "c1ce",
	"./หมึกกล้วย.png": "60ec",
	"./หอยกาบ.jpg": "1a9f",
	"./หอยนางรม.jpg": "e08a",
	"./หอยหลอด.jpg": "96c1",
	"./หอยเชลล์.jpg": "5600",
	"./หอยแครง.jpg": "e128",
	"./หอยแมลงภู่.jpg": "d02a",
	"./หอยโข่ง.jpg": "ed6e",
	"./เนื้อปลาแอนโชวี่.jpg": "dbc7",
	"./เนื้อปู.jpg": "c28f",
	"./เนื้อหมูป่า.jpg": "64cd",
	"./ไก่งวง.jpg": "5e24",
	"./ไข่ปลาคาร์เวียร์.jpg": "d298"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "839e";